export default __webpack_public_path__ + "static/media/oa_3.8bf690cb.mp3";